/**
 * Feature flags for gating functionality.
 * Flip these to true when ready to enable.
 */

/** AutoTrader valuations — disabled pending commercial licence. */
export const AUTOTRADER_ENABLED = true;
